<template>
    <div class="row">
        <div class="col-lg-12 col-xl-8">
            <pre-order-unit-detail-form
                :pre-order-unit="preOrderUnit"
                :updating="updating"
                :manufacturers="manufacturers"
                :selected-manufacturer="selectedManufacturer"
                @searchManufacturers="$emit('searchManufacturers', $event)"
                @updateUnit="$emit('updateUnit', $event)"
            />
        </div>
    </div>
</template>
<script>
import PreOrderUnitDetailForm from "./PreOrderUnitDetailForm.vue";

export default {
    name: "PreOrderUnit",
    components: { PreOrderUnitDetailForm },
    props: {
        preOrderUnit: {
            type: Object,
            required: true,
        },
        updating: {
            type: Boolean,
            required: true,
        },
        manufacturers: {
            type: Array,
            required: true,
        },
        selectedManufacturer: {
            type: Object,
            required: true,
        },
    },
};
</script>
